// ========================================
// FUM Collections Banner Menu Scroll Effects
// ========================================

document.addEventListener('DOMContentLoaded', function() {
  const menuScroll = document.querySelector('.fum-collections-banner-menu-scroll');
  const menuContainer = document.querySelector('.fum-collections-banner-menu');
  
  if (menuScroll && menuContainer) {
    // Debug: Log scroll container properties
    console.log('Menu scroll container found:', menuScroll);
    console.log('Scroll width:', menuScroll.scrollWidth);
    console.log('Client width:', menuScroll.clientWidth);
    console.log('Overflow X:', getComputedStyle(menuScroll).overflowX);
    
    // Check if scrolling is needed
    const needsScrolling = menuScroll.scrollWidth > menuScroll.clientWidth;
    // console.log('Needs scrolling:', needsScrolling);
    function updateFadeEffects() {
      const scrollLeft = menuScroll.scrollLeft;
      const maxScrollLeft = menuScroll.scrollWidth - menuScroll.clientWidth;
      
      // Update left fade
      if (scrollLeft <= 0) {
        menuContainer.classList.add('fade-left');
      } else {
        menuContainer.classList.remove('fade-left');
      }
      
      // Update right fade
      if (scrollLeft >= maxScrollLeft) {
        menuContainer.classList.add('fade-right');
      } else {
        menuContainer.classList.remove('fade-right');
      }
    }
    
    // Initial fade state
    updateFadeEffects();
    
    // Update fade effects on scroll
    menuScroll.addEventListener('scroll', updateFadeEffects);
    
    // Update fade effects on window resize
    window.addEventListener('resize', updateFadeEffects);
    
    // Touch/swipe support for mobile devices
    let isScrolling = false;
    let startX = 0;
    let scrollLeft = 0;
    
    menuScroll.addEventListener('touchstart', function(e) {
      isScrolling = true;
      startX = e.touches[0].pageX - menuScroll.offsetLeft;
      scrollLeft = menuScroll.scrollLeft;
    });
    
    menuScroll.addEventListener('touchmove', function(e) {
      if (!isScrolling) return;
      e.preventDefault();
      const x = e.touches[0].pageX - menuScroll.offsetLeft;
      const walk = (x - startX) * 2;
      menuScroll.scrollLeft = scrollLeft - walk;
    });
    
    menuScroll.addEventListener('touchend', function() {
      isScrolling = false;
    });
  }

  // ========================================
  // Sticky Menu Functionality
  // ========================================
  
  const bannerSection = document.querySelector('.fum-new-coll-banner');
  let stickyMenu = null;
  let isStickyMenuVisible = false;
  const scrollThreshold = 200; // Scroll level to show sticky menu
  
  function createStickyMenu() {
    if (stickyMenu) return; // Already created
    
    const originalMenu = document.querySelector('.fum-collections-banner-menu');
    if (!originalMenu) return;
    
    // Clone the menu
    stickyMenu = originalMenu.cloneNode(true);
    stickyMenu.classList.add('fum-sticky-menu');
    stickyMenu.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      z-index: 1000;
      background: white;
      box-shadow: 0 2px 10px rgba(0,0,0,0.1);
      transform: translateY(-100%);
      transition: transform 0.3s ease-in-out;
      opacity: 0;
    `;
    
    // Add to body
    document.body.appendChild(stickyMenu);
    
    // Copy scroll position from original menu
    const originalMenuScroll = originalMenu.querySelector('.fum-collections-banner-menu-scroll');
    const stickyMenuScroll = stickyMenu.querySelector('.fum-collections-banner-menu-scroll');
    
    if (originalMenuScroll && stickyMenuScroll) {
      stickyMenuScroll.scrollLeft = originalMenuScroll.scrollLeft;
      
      // Sync scroll positions
      originalMenuScroll.addEventListener('scroll', function() {
        stickyMenuScroll.scrollLeft = originalMenuScroll.scrollLeft;
      });
      
      stickyMenuScroll.addEventListener('scroll', function() {
        originalMenuScroll.scrollLeft = stickyMenuScroll.scrollLeft;
      });
    }
    
    // Add fade effects to sticky menu
    if (stickyMenuScroll) {
      function updateStickyFadeEffects() {
        const scrollLeft = stickyMenuScroll.scrollLeft;
        const maxScrollLeft = stickyMenuScroll.scrollWidth - stickyMenuScroll.clientWidth;
        
        if (scrollLeft <= 0) {
          stickyMenu.classList.add('fade-left');
        } else {
          stickyMenu.classList.remove('fade-left');
        }
        
        if (scrollLeft >= maxScrollLeft) {
          stickyMenu.classList.add('fade-right');
        } else {
          stickyMenu.classList.remove('fade-right');
        }
      }
      
      updateStickyFadeEffects();
      stickyMenuScroll.addEventListener('scroll', updateStickyFadeEffects);
    }
    
    // Add touch/swipe support to sticky menu
    if (stickyMenuScroll) {
      let isStickyScrolling = false;
      let stickyStartX = 0;
      let stickyScrollLeft = 0;
      
      stickyMenuScroll.addEventListener('touchstart', function(e) {
        isStickyScrolling = true;
        stickyStartX = e.touches[0].pageX - stickyMenuScroll.offsetLeft;
        stickyScrollLeft = stickyMenuScroll.scrollLeft;
      });
      
      stickyMenuScroll.addEventListener('touchmove', function(e) {
        if (!isStickyScrolling) return;
        e.preventDefault();
        const x = e.touches[0].pageX - stickyMenuScroll.offsetLeft;
        const walk = (x - stickyStartX) * 2;
        stickyMenuScroll.scrollLeft = stickyScrollLeft - walk;
      });
      
      stickyMenuScroll.addEventListener('touchend', function() {
        isStickyScrolling = false;
      });
    }
  }
  
  function updateStickyMenu() {
    if (!stickyMenu) {
      createStickyMenu();
    }
    
    if (!stickyMenu) return;
    
    const scrollY = window.scrollY;
    
    if (scrollY > scrollThreshold && !isStickyMenuVisible) {
      // Show sticky menu
      stickyMenu.style.transform = 'translateY(0)';
      stickyMenu.style.opacity = '1';
      isStickyMenuVisible = true;
    } else if (scrollY <= scrollThreshold && isStickyMenuVisible) {
      // Hide sticky menu
      stickyMenu.style.transform = 'translateY(-100%)';
      stickyMenu.style.opacity = '0';
      isStickyMenuVisible = false;
    }
  }
  
  // Initialize sticky menu on page load
  createStickyMenu();
  
  // Update sticky menu on scroll
  window.addEventListener('scroll', updateStickyMenu);
  
  // Update sticky menu on resize
  window.addEventListener('resize', function() {
    if (stickyMenu) {
      // Recreate sticky menu on resize to ensure proper positioning
      stickyMenu.remove();
      stickyMenu = null;
      isStickyMenuVisible = false;
      createStickyMenu();
      updateStickyMenu();
    }
  });

  // ========================================
  // Collection Anchor Link Smooth Scrolling
  // ========================================
  
  const collectionAnchorLinks = document.querySelectorAll('.collection-anchor-link');
  
  collectionAnchorLinks.forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      
      const href = this.getAttribute('href');
      const collectionId = this.getAttribute('data-collection-id');
      const collectionUrl = this.getAttribute('data-collection-url');
      const anchorId = this.getAttribute('data-anchor-id');
      
      // If it's just a hash without an anchor ID, do nothing
      if (href === '#' || !anchorId) {
        return;
      }
      
      // Try to find the target section by anchor ID first
      const targetSection = document.getElementById(anchorId);
      
      if (targetSection) {
        // Smooth scroll to the target section
        targetSection.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest'
        });
        
        // Update URL hash without triggering scroll
        history.pushState(null, null, href);
      } else {
        // If section not found by anchor ID, try to find it by collection ID
        if (collectionId) {
          const sectionsByCollectionId = document.querySelectorAll(`[data-collection-id="${collectionId}"]`);
          
          if (sectionsByCollectionId.length > 0) {
            // Scroll to the first matching section
            sectionsByCollectionId[0].scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
            
            // Update URL hash
            history.pushState(null, null, href);
          } else {
            // If no section found by collection ID either, log the issue
            console.log('Target section not found for anchor ID:', anchorId, 'or collection ID:', collectionId);
            
            // Optionally redirect to collection page if available
            if (collectionUrl) {
              console.log('Redirecting to collection page:', collectionUrl);
              // Uncomment the line below if you want to redirect to collection page
              // window.location.href = collectionUrl;
            }
          }
        } else {
          console.log('No anchor ID or collection ID found for link:', href);
        }
      }
    });
  });
}); 